import React from "react";
import { withStyles, Button, Divider, Grid } from "@material-ui/core";
import CircularProgress from '@material-ui/core/CircularProgress';
import { postData } from "../../../../../api/componentAPIs";
import MESSAGES from "../../../../../appMessages";
import { convertDateTimeToTimeString, minutesToTime } from '@dataGrid/gridUtilities';
import AnimationRenderer from "../../../../animations/animationRenderer";
import * as TickAnimation from "../../../../animations/json/TickMark.json";
import styles from "./styles";
class LassoFeedback extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            undoInProgress: false
        }
        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }
    undoRouteCreation = () => {
        const requestObj = {
            scenarioId: this.props.scenarioId,
            scenarioVersionId: this.props.scenarioVersionId
        }
        this.setState({
            undoInProgress: true
        });
        postData("Undo", requestObj).then(response => {
            if (response && response.status >= 200 && response.status < 400) {
                this.props.undo();
                return;
            }
            this.handleError(response.status);
        }, () => {
            this.handleError();
        });
    }

    handleError = (statusCode) => {
        if (this._isMounted) {
            this.setState({
                undoInProgress: false
            });
        }
        if (statusCode === 403) {
          return;
        }
        this.props.enqueueSnackbar(MESSAGES.LASSO.UNDO_FAILED, { variant: "error" }); 
    }   
    
    render() {
        const { classes, route, isNew } = this.props;   
        return (
            <React.Fragment>
                <Divider className={classes.divider} />
                <div className={classes.head}>
                    <Grid container spacing={16} classes={{ container: classes.group }}>
                        <Grid item xs={1}><AnimationRenderer animationJSON={TickAnimation} dimension="20px" /></Grid>
                        <Grid item xs={10}>Route : {route.routeName} {isNew ? "Created" : "Updated"}</Grid>
                    </Grid>
                </div>
                <Divider className={classes.divider} />
                <div className={`${classes.data} customScroll`}>
                    <Grid container spacing={16} classes={{ container: classes.group }}>
                        <Grid item xs={12}>Route Details</Grid>
                        <Grid item xs={4}>Pros</Grid>
                        <Grid item xs={2}>{route.prosCount}</Grid>
                        <Grid item xs={4}>Priority</Grid>
                        <Grid item xs={2}>{route.priorityProCount}</Grid>
                        <Grid item xs={4}>HU</Grid>
                        <Grid item xs={2}>{route.totalHu}</Grid>
                        <Grid item xs={4}>Special Needs</Grid>
                        <Grid item xs={2}>{route.specialNeedsProCount}</Grid>
                        <Grid item xs={4}>Weight</Grid>
                        <Grid item xs={8}>{route.totalWeight}</Grid>
                        <Grid item xs={4}>Trailer Type</Grid>
                        <Grid item xs={8}>{route.trailerName}</Grid>
                        <Grid item xs={4}>Start Time</Grid>
                        <Grid item xs={8}>{convertDateTimeToTimeString(route.startTime)}</Grid>
                        <Grid item xs={4}>Total Time</Grid>
                        <Grid item xs={8}>{minutesToTime({ value: route.totalTime })}</Grid>
                        <Grid item xs={4}>Total Miles</Grid>
                        <Grid item xs={8}>{`${route.totalMiles ? route.totalMiles + ' miles' : ''}`} </Grid>
                        <Grid item xs={4}>Missed Apts</Grid>
                        <Grid item xs={8}>{route.numServiceViolations}</Grid>
                        <Grid item xs={4}></Grid>
                        <Grid item xs={8} classes={{ item: classes.actionContainer }}>
                            <Button
                                size="small"
                                variant="outlined"
                                color="primary"
                                onClick={this.undoRouteCreation}
                                disabled={this.state.undoInProgress}
                                classes={{
                                    root: `${classes.actionButton} ${this.state.undoInProgress ? classes.activeButton : ''}`,
                                    disabled: classes.actionDisabled
                                }}
                            >
                                {this.state.undoInProgress ? <CircularProgress size={16} color="primary" /> : "Undo"}
                            </Button>
                            <Button
                                size="small"
                                variant="outlined"
                                color="primary"
                                onClick={this.props.close}
                                disabled={this.state.undoInProgress}
                                classes={{
                                    root: classes.actionButton,
                                    disabled: classes.actionDisabled
                                }}
                            >
                                Close
                        </Button>
                        </Grid>
                        {this.state.errorMessage && (
                            <React.Fragment>
                                <Grid item xs={4}></Grid>
                                <Grid item xs={8} classes={{ item: classes.errorMessage }}>{this.state.errorMessage}</Grid>
                            </React.Fragment>
                        )}
                    </Grid>
                </div>
            </React.Fragment>
        )
    }
}
export default withStyles(styles)(LassoFeedback);